import React from "react";
import Header from "./components/Header";
import Intro from "./components/Intro";
import WorkPortfolio from "./components/WorkPortfolio";
import "./styles/App.css";
import Internships from "./components/Internships";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Intro />
        <WorkPortfolio />
        <Internships />
      </main>
      <Footer />
    </div>
  );
}

export default App;
